import React from "react";

const PublishedInfoSection = (props) => {
  return (
    <div className="published-info-container">
      <div className="title">掲載情報について</div>
      <div className="text">
        本ホームページに掲載されている事項は、野村グループ各社に関する情報の提供を目的としたものであり、証券投資の勧誘を目的としたものではありません。最終的な投資決定は、お客さまご自身の判断でなさるようにお願いいたします。また、当社は、当該情報の正確性および完全性を保証または約束するものでなく、今後、予告なしに内容を変更又は廃止する場合があります。なお、当該情報の欠落・誤謬等につきましてはその責を負いかねますのでご了承ください。
        <br />
        <br />
        本ホームページに記載されている内容の著作権は、原則として、野村ホールディングス株式会社に帰属します。著作権法により、当社に無断で転用、複製等することはできません。但し、個別に条件が提示されている場合は、当該条件が優先するものとします。
        <br />
        <br />
        本ホームページから、リンクやバナーによって野村グループ各社をはじめ他のホームページに移動される場合があります。移動された先のホームページは野村ホールディングス株式会社が運営するものではございません。よって、その内容の真偽等につきまして野村ホールディングス株式会社は責任を負いかねますのでご了承ください。
        <br />
        <br />
        本ホームページに掲載されている資料は、将来の予測等に関する情報を含む場合がありますが、これらの情報はあくまで当社の予測であり、その時々の状況により変更を余儀なくされることがあります。なお、変更があった場合でも当社は当該資料を改訂する義務を負いかねますのでご了承ください。
      </div>
      <div className="subhead">Cookie（クッキー）について</div>
      <div className="text">
        当サイト内のページにおいて、Cookie（クッキー）の機能を使用しております。Cookieとは、Webサーバーとブラウザの間でやりとりされる小さなデータです。このデータはプログラムとして実行されません。したがって、プログラムやウィルスを含むことはございません。
        <br />
        <br />
        Cookieは、一般に、お客さまがWebサイトを訪れていただいた際の設定内容を、再訪問の際に認識するために使われます。また、サイト改善のために、アクセス状況の傾向や統計の分析に使用することがありますが、それ以外の目的には使用いたしません。この機能を有効にするためには、Cookieを受け入れる設定を有効にする必要がありますが、ブラウザ側の設定や管理は、お客さまの責任においておこなっていただくものとします。なお、このCookieの受け入れを無効にした場合、一部のサービスをご利用いただけない場合もございますので、何卒ご了承ください。
      </div>
      <div className="subhead">推奨環境</div>
      <div className="flex-row-vertical-center">
        <div className="table-header">端末</div>
        <div className="table-header">OS</div>
        <div className="table-header final-table-cell">ブラウザ</div>
      </div>
      <div className="flex-row-vertical-center table-content-background">
        <div className="table-content">パソコン</div>
        <div className="table-content">
          <div>Windows 8.1 以上</div>
          <div>Mac OS 10.14以上</div>
        </div>
        <div className="table-content final-table-cell">
          <div>Internet Explorer 11 以上</div>
          <div>Edge 最新版</div>
          <div>Firefox 最新版</div>
          <div>Chrome 最新版</div>
          <div>Safari 最新版</div>
        </div>
      </div>
      <div className="flex-row-vertical-center">
        <div className="table-content">スマートフォン</div>
        <div className="table-content">
          <div>iOS 12 以上</div>
          <div>Android OS 6 以上</div>
        </div>
        <div className="table-content final-table-cell">
          <div>iOS 標準ブラウザ</div>
          <div>Chrome 最新版</div>
        </div>
      </div>
      <div className="flex-row-vertical-center table-content-background">
        <div className="table-content">タブレット</div>
        <div className="table-content">iOS 12以上</div>
        <div className="table-content final-table-cell">iOS 標準ブラウザ</div>
      </div>
      <br />
      <div className="text">
        当野村ホールディングスホームページの一部ページでは、各種書類の閲覧、動画の再生の為に以下のプラグインソフトを使用しています。当サイト内のコンテンツが正常に閲覧、再生できない場合は以下よりそれぞれ最新のプラグインソフトをダウンロードし、インストールしてご利用ください。
      </div>
      <div className="link">
        <img alt="" src={require("@/assets/images/arrow-right.svg")} />
        <a href="#" className="text">
          Adobe Reader ダウンロード
        </a>
      </div>
      <br />
      <div className="text-small">
        Firefoxをご利用の方で、Adobe
        Readerのプラグインをインストールしていても本ホームページ内のPDFがご覧になれない場合がございます。
        ブラウザの設定を変更することで閲覧できる場合がございますので、お手数ですが下記の方法をお試しください。
      </div>
    </div>
  );
};

export default PublishedInfoSection;
